import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AttentionItem, HospitalStat } from 'src/app/leader-toolkit/models/hospital-dashboard.model';

@Component({
  selector: 'vc-hospital-attention-card',
  templateUrl: './hospital-attention-card.component.html',
  styleUrl: './hospital-attention-card.component.scss',
  standalone: false,
})
export class HospitalAttentionCardComponent {
  @Input() eyebrow = '';
  @Input() headline = '';
  @Input() sub = '';
  @Input() attention: AttentionItem[] = [];
  @Input() stats: HospitalStat[] = [];
  @Input() refreshedAt = '';
  @Input() isClear = false;
  @Input() hasGoals = true;

  @Output() openGoal = new EventEmitter<number>();
  @Output() openTasks = new EventEmitter<void>();

  onItemClick(item: AttentionItem): void {
    if (item.linkTo === 'tasks') {
      this.openTasks.emit();
    } else if (item.goalTargetId) {
      this.openGoal.emit(item.goalTargetId);
    }
  }
}